import '../style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { ResultBody, ResultHeader } from 'views/mutual/result';
import { CompatibilityCheckQuestionToAnswer, MultiSelectionAnswer, SelectAndTextAnswer } from '../../hooks';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { useNavigate } from 'react-router-dom';
import { PagePath } from 'constants/pagePath';
import { Caption } from 'views/mutual/caption';

export enum ConfirmType{
  OnlyConfirm,
  ShowOnStart,
  AfterInput,
}

type QuestionConfirmPageProps = {
  questionToAnswers: Array<CompatibilityCheckQuestionToAnswer>;
  confirmType : ConfirmType;
  onSubmit?: () => void;
  backQuestion?: () => void;  
  navigateToEditPage? : () => void
};

export const QuestionConfirmPage = (props: QuestionConfirmPageProps) => {
  const navigate = useNavigate();
  return(
    <>
    <div className="compatibilityCheck">
      <div className="compatibilityCheck_result">
        {props.confirmType == ConfirmType.ShowOnStart && (
            <Description label=
{` 前回のご回答内容は、以下の通りです。
 内容をご確認の上、前回から変更なければ、「前回の回答内容で回答する」よりお進みください。
 変更がある場合は、「回答内容を修正する」よりご回答をお願いいたします。
`}
              labelSize={labelSize.medium}
            />
        )}
        {props.confirmType == ConfirmType.OnlyConfirm && (
          <Description
            label={` 前回のご回答内容は、以下の通りです。`}
            labelSize={labelSize.medium}
          />
        )}

        <Caption label="入力内容の確認" />
        {props.questionToAnswers.map((qa, index) => (
          <QuestionAnswer key={qa.question.key} {...qa} />
        ))}
      </div>

      {props.confirmType == ConfirmType.ShowOnStart && (
        <>
        <div className="compatibilityCheck_button-container">
            <Button
              label={'前回の回答内容で回答する'}
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.medium}
              onClick={props.onSubmit}
            />
            <Button
              label={'回答内容を修正する'}
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.medium}
              onClick={props.navigateToEditPage}
            />       
          </div>
          <div className="compatibilityCheck_buttons">
            <Button
              label="前の画面に戻る"
              buttonFill={ButtonFill.link}
              buttonSize={ButtonSize.small}
              onClick={() => navigate(PagePath.Home)}
            />
          </div>        
        </>
      )}
      
      {props.confirmType == ConfirmType.AfterInput && (
        <div className="compatibilityCheck_buttons">
          <Button
            label="回答を確認して完了"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={props.onSubmit}
          />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={props.backQuestion}
          />
        </div>
      )}
    </div>
  </>
  );
};

const QuestionAnswer: React.FC<CompatibilityCheckQuestionToAnswer> = (qa: CompatibilityCheckQuestionToAnswer) => {
  switch (qa.question.kind) {
    case 'yesOrNo':
      if(typeof qa.answer === "boolean"){
        return <YesOrNoQuestionAnswer questionText={qa.question.questionText} answer={qa.answer as boolean} />;
      }
      return <ConfirmOnlyQuestionAnswer questionText={qa.question.questionText} answer={qa.answer as string} />;     
    case 'selectAndText':
    case 'selectOnly':
      return (
        <SelectAndTextQuestionAnswer
          questionText={qa.question.questionText}
          answer={qa.answer as SelectAndTextAnswer}
        />
      );
    case 'groupYesOrNo':
      const yesOrNo = qa.answer as Array<boolean>;
      return (
        <>
          {qa.question.questionTexts.map((questionText, i) => (
            <YesOrNoQuestionAnswer key={i} questionText={questionText} answer={yesOrNo[i]} />
          ))}
        </>
      );
    case 'multiSelection':
      return <MultiSelectionQuestionAnswer questionText={qa.question.questionText} answer={qa.answer as MultiSelectionAnswer} />;     
  }
};

type YesOrNoQuestionAnswerProps = {
  questionText: string;
  answer: boolean;
};

const YesOrNoQuestionAnswer: React.FC<YesOrNoQuestionAnswerProps> = (qa: YesOrNoQuestionAnswerProps) => {
  return (
    <>
      <ResultHeader label={qa.questionText} />
      <ResultBody label={qa.answer ? 'はい' : 'いいえ'} />
    </>
  );
};

type ConfirmOnlyQuestionAnswerProps = {
  questionText: string;
  answer: string;
};

const ConfirmOnlyQuestionAnswer: React.FC<ConfirmOnlyQuestionAnswerProps> = (qa: ConfirmOnlyQuestionAnswerProps) => {
  return (
    <>
      <ResultHeader label={qa.questionText} />
      <ResultBody label={qa.answer} />
    </>
  );
};

type SelectAndTextQuestionAnswerProps = {
  questionText: string;
  answer: SelectAndTextAnswer;
};

const SelectAndTextQuestionAnswer: React.FC<SelectAndTextQuestionAnswerProps> = (
  qa: SelectAndTextQuestionAnswerProps,
) => {
  const answerLabel = qa.answer.values.map((answerValue) => answerValue.label).join('/');
  return (
    <>
      <ResultHeader label={qa.questionText} />
      <ResultBody label={answerLabel} />
      <ResultBody label={qa.answer.text} />
    </>
  );
};

type MultiSelectionQuestionAnswerProps = {
  questionText: string;
  answer: MultiSelectionAnswer;
};

const MultiSelectionQuestionAnswer: React.FC<MultiSelectionQuestionAnswerProps> = (
  qa: MultiSelectionQuestionAnswerProps,
) => {
  return (
    <>
      <ResultHeader label={qa.questionText} />
      <ResultBody label={qa.answer.label} />
    </>
  );
};